import { routes } from "../../../routes";

const stationSlugParam = "stationSlug";

const getSafeStationSlug = (
  stationSlug: string | undefined,
): string | undefined => {
  const normalizedStationSlug = stationSlug?.trim();

  return normalizedStationSlug ? normalizedStationSlug : undefined;
};

const buildAuthRedirectPath = (
  authPath: string,
  nextPath: string,
  stationSlug?: string,
): string => {
  const searchParams = new URLSearchParams({ next: nextPath });
  const normalizedStationSlug = getSafeStationSlug(stationSlug);

  if (normalizedStationSlug) {
    searchParams.set(stationSlugParam, normalizedStationSlug);
  }

  return `${authPath}?${searchParams.toString()}`;
};

export const buildLoginRedirectPath = (
  nextPath: string,
  stationSlug?: string,
): string => buildAuthRedirectPath(routes.auth.login, nextPath, stationSlug);

export const buildRegisterRedirectPath = (
  nextPath: string,
  stationSlug?: string,
): string => buildAuthRedirectPath(routes.auth.register, nextPath, stationSlug);

export const getAuthRedirectContext = (
  searchParams: URLSearchParams,
): {
  nextPath: string;
  stationSlug?: string;
} => {
  const next = searchParams.get("next");

  const nextPath =
    !next ||
    next.startsWith(routes.auth.login) ||
    next.startsWith(routes.auth.register) ||
    !next.startsWith("/") ||
    next.startsWith("//")
      ? routes.account
      : next;

  return {
    nextPath,
    stationSlug: getSafeStationSlug(
      searchParams.get(stationSlugParam) ?? undefined,
    ),
  };
};
